import React from 'react';
import { NavLink } from 'react-router-dom';

import { XIcon } from '../../icons/XIcon';
import { RoundTableLogo } from '../../images/logos/RoundTableLogo';

import '../../../css/components/side-navbar.scss';

export class SideNavbar extends React.Component {
  render() {
    const navbarLinks = [
      {
        type: "link",
        text: "home",
        target: "/",
      },
      {
        type: "link",
        text: "about us",
        target: "/about-us",
      },
      {
        type: "link",
        text: "services",
        target: "/services",
      },
      {
        type: "link",
        text: "resources",
        target: "/resources",
      },
    ]
    const links = navbarLinks.map((link, index) => {
      return (
        <div key={ index } className="link-wrapper">
          <NavLink className="navbar-link" onClick={ this.props.close } to={ link.target }>{ link.text }</NavLink>
          <div className="underline-space"></div>
        </div>
        
      )
    })

    return (
      <div className={`side-navbar ${this.props.expanded ? 'side-navbar--expanded':''}`}>
        <div className="top-row">
          <div className="left-side">
            <RoundTableLogo color />
          </div>
          <div className="right-side">
            <XIcon onClick={ this.props.close } /> 
          </div>
        </div>

        <div className="bottom-half">
          <div className="left-side main-links">
            { links }
          </div>
          <div className="right-side contact-section">
            <div className="contact-row contact-us">contact us</div>
            <div className="contact-row phone--home">
              <img className="contact-icon" src={ "images/icons/phone-black.svg" } />801-400-9008
            </div>
            <div className="contact-row email">
              <img className="contact-icon" src={ "images/icons/email-black.svg" } /> wade12.healy@gmail.com
            </div>
          </div>
        </div>
        
        
        
      </div>
    )
  }
}